import { useQueryClient, useMutation } from '@tanstack/react-query';
import { searchQueryKeys } from '../queries/searchQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';

const useMutationRecentSearchRemoveAll = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const recentSearchQueryKey = searchQueryKeys.recentSearch();
  return useMutation({
    mutationFn: async () => client.v2("/v2/search/history", {
      method: "delete",
      body: {}
    }),
    onMutate: async () => {
      await queryClient.cancelQueries({
        queryKey: recentSearchQueryKey
      });
      const previousRecentSearches = queryClient.getQueryData(recentSearchQueryKey);
      queryClient.setQueryData(recentSearchQueryKey, []);
      return {
        previousRecentSearches
      };
    },
    onError: (err, _, context) => {
      toast({
        content: "Failed to clear recent search history."
      });
      queryClient.setQueryData(recentSearchQueryKey, context?.previousRecentSearches || []);
    }
  });
};

export { useMutationRecentSearchRemoveAll };
//# sourceMappingURL=useMutationRecentSearchRemoveAll.js.map
